import { maskCep, maskCnpj, maskCpf, maskPhone } from './masks';

const LOCALE = 'pt-BR';
const DEFAULT_TZ = 'America/Sao_Paulo';

const brl = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'BRL' });

/** Dinheiro trafega em centavos inteiros. */
export const formatCurrency = (cents: number | null | undefined) => (cents == null ? '' : brl.format(cents / 100));

/** "1234,56" (sem símbolo) a partir de centavos. */
export const formatCentsPlain = (cents: number) =>
  new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);

function toDate(v: string | Date): Date {
  if (v instanceof Date) return v;
  // data pura (AAAA-MM-DD) é tratada como dia civil, sem deslocamento de fuso
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split('-').map(Number) as [number, number, number];
    return new Date(y, m - 1, d, 12);
  }
  return new Date(v);
}

const isDateOnly = (v: string | Date) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);

export function formatDate(v: string | Date | null | undefined, tz = DEFAULT_TZ): string {
  if (!v) return '';
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: 'short', timeZone: isDateOnly(v) ? undefined : tz }).format(toDate(v));
}

export function formatDateLong(v: string | Date | null | undefined, tz = DEFAULT_TZ): string {
  if (!v) return '';
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: 'long', timeZone: isDateOnly(v) ? undefined : tz }).format(toDate(v));
}

export function formatTime(v: string | Date | null | undefined, tz = DEFAULT_TZ): string {
  if (!v) return '';
  return new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit', timeZone: tz }).format(toDate(v));
}

export function formatDateTime(v: string | Date | null | undefined, tz = DEFAULT_TZ): string {
  if (!v) return '';
  return `${formatDate(v, tz)} ${formatTime(v, tz)}`;
}

/** "08:00:00" (coluna time do Postgres) -> "08:00". */
export const formatHHmm = (v: string) => v.slice(0, 5);

export const formatCpf = (v: string | null | undefined) => (v ? maskCpf(v) : '');
export const formatCnpj = (v: string | null | undefined) => (v ? maskCnpj(v) : '');
export const formatCep = (v: string | null | undefined) => (v ? maskCep(v) : '');
export const formatPhone = (v: string | null | undefined) => (v ? maskPhone(v) : '');

export const WEEKDAYS = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'] as const;

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
